import { createContext } from 'react';
import RootStore from 'stores/root_store';

const RootStoreContext = createContext<RootStore>(null);

export default RootStoreContext;
